<div class="navbar">
	<div class="navbar__backButton">
		<i class="navbar__backButton__icon"></i>
	</div>
	<div class="navbar__close">
		<i class="navbar__close__icon"></i>
	</div>
</div>
